import { ChevronDownIcon } from '@shared/components/Icons';
import clsx from 'clsx';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Address } from 'viem';

function shorten(address: Address) {
  return address.length > 10 ? `${address.slice(0, 4)}...${address.slice(-4)}` : address;
}

export const AccountModalButton: React.FC<{
  openAccountModal: VoidFunction,
  address: Address,
  className?: string,
}> = ({ openAccountModal, address, className }) => {
  const { t } = useTranslation();

  return (
    <button
      onClick={openAccountModal}
      type="button"
      className={clsx(
        'flex w-full flex-row items-center justify-between gap-2 lg:w-auto',
        'h-[42px] rounded-md  transition-all duration-200 hover:bg-[#ECEAED33] lg:border-2 lg:border-[#ECEAED33] lg:px-2',
        className,
      )}
    >
      <div className="text-[17.5px] font-black tracking-normal lg:hidden">{t('walletContent.wallet')}</div>

      <div className="flex flex-row items-center gap-2">
        <div className="font-bold tracking-wide text-[#C4D0E4] lg:text-[#ECEAED]">
          {shorten(address)}
        </div>
        <ChevronDownIcon className="size-5" />
      </div>
    </button>
  );
};
